import { zSchema } from "@zeal/common";
import {
  baseIDUploadLinkSchema,
  TIDUploadLinkResponse,
} from "../shared/idUploadTypes";

/**
 * Request schema for generating employee document upload links (private route)
 * Extends the shared base schema with employee-specific fields (no testMode for private routes)
 */
export const postGenerateEmployeeIDUploadLinkPrivateSchema =
  baseIDUploadLinkSchema.extend({
    employeeID: zSchema.string().min(1, "Employee ID is required"),
  });

export type TPostGenerateEmployeeIDUploadLinkPrivateRequest = zSchema.infer<
  typeof postGenerateEmployeeIDUploadLinkPrivateSchema
>;

export type TPostGenerateEmployeeIDUploadLinkPrivateResponse =
  TIDUploadLinkResponse;
